import { Component, OnInit, OnDestroy, Input, Output, EventEmitter, ViewContainerRef } from '@angular/core';
import { DataService, OptionsserviceService, LoansService, StorageService, CustomerService } from '../../_services/index';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { Loan_ } from '../../_models/loan_';
import { IMyDpOptions } from 'mydatepicker';
import { IMyDateModel, IMyInputFieldChanged, IMyCalendarViewChanged, IMyInputFocusBlur, IMyMarkedDate, IMyDate, IMySelector } from 'mydatepicker';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-prepayment',
  templateUrl: './prepayment.component.html',
  styleUrls: ['./prepayment.component.css']
})
export class PrepaymentComponent implements OnInit {
  finished = false;
  @Input('loan') loan:any;
  public myForm: FormGroup;
  currentUser:any;
  loading = false;
  repayments:any;
  view = 'form';
  constructor(private toastr: ToastrService, vcr: ViewContainerRef, private DataService: DataService, public router: Router,
    public _fb: FormBuilder, public storageService: StorageService,
    public customerService: CustomerService,
    public optionsService: OptionsserviceService, public loansService: LoansService) {
    this.currentUser = this.storageService.read<any>('currentUser');
  }

  showSuccess(msg) {
    this.toastr.success(msg);
  }
  showError(msg) {
    this.toastr.error(msg);
  }
  ngOnInit() {
    this.newloan()
  }

  newloan() {

    this.myForm = this._fb.group({
      REQUEST_ID: ['', <any>Validators.required],
      AMOUNT_PAID: ['', <any>Validators.required],
      PAYMENT_DATE: ['', <any>Validators.required],
      SEND_PAYMENT_RECEIVED:[''],
      //PASSWORD: ['', <any>Validators.required],
      NARRATION: '',
    });
    (<FormControl>this.myForm.controls['REQUEST_ID'])
      .setValue(this.loan.request_id, { onlySelf: true });
  }
  showForm(){
    this.view = 'form';
  }
  save(value, valid){
    this.loading = true;
    this.loansService.submitPrepayment(this.currentUser.token, this.myForm.value)
      .subscribe(result => {
        this.showSuccess("Request Successful")
        this.loading = false;
        this.finished = true;
        // this.repayments = result.data.schedule;
        // this.view = 'schedule';
      });
  }
  preview(){
    this.loading = true;
    this.loansService.previewPrepayment(this.currentUser.token, this.myForm.value)
      .subscribe(result => {

        this.loading = false;
        this.repayments = result.data.schedule;
        this.view = 'schedule';
      });
  }
  getTotal(key, schedule) {
    if (schedule === undefined) { } else {
      let total = 0;
      if (key === 'INITIAL_PRINCIPAL') {
        total = schedule.reduce(function (cnt, o) { return cnt + parseFloat(o.INITIAL_PRINCIPAL); }, 0);
      }
      if (key === 'PRINCIPAL_REPAYMENT') {
        total = schedule.reduce(function (cnt, o) { return cnt + parseFloat(o.PRINCIPAL_REPAYMENT); }, 0);
      }
      if (key === 'INTEREST_REPAYMENT') {
        total = schedule.reduce(function (cnt, o) { return cnt + parseFloat(o.INTEREST_REPAYMENT); }, 0);
      }
      if (key === 'FEES') {
        total = schedule.reduce(function (cnt, o) { return cnt + parseFloat(o.FEES) + parseInt(o.VAT_ON_FEES); }, 0);
      }
      if (key === 'TERM_REPAYMENT') {
        total = schedule.reduce(function (cnt, o) { return cnt + parseFloat(o.TERM_REPAYMENT); }, 0);
      }
      return total;
    }
    //

  }
}
